import { forwardRef, useEffect, useRef } from 'react';

export default forwardRef(function TextInput({ type = 'text', placeholder = '', className = '', isFocused = false, ...props }, ref) {
    const input = ref ? ref : useRef();

    useEffect(() => {
        if (isFocused) {
            input.current.focus();
        }
    }, []);

    return (
        <div className='relative z-0 mb-5'>
            <input
                {...props}
                type={type}
                className={
                    'cursor-text px-5 py-4 transition-all border-0 border-b-[1px] border-gray-300 outline-none ring-0 focus:border-primary focus:outline-none peer focus:ring-0 ' +
                    className
                }
                placeholder={placeholder}
                ref={input}
            />
            {placeholder.length > 0 && <label htmlFor={props.id} className="cursor-text absolute duration-300 top-4 left-5 -z-1 origin-top-left text-gray-400 start-0 peer-focus:text-primary scale-75 -translate-y-8 rtl:translate-x-1/4 rtl:left-aut0">{props.label}</label>}
            {placeholder.length === 0 && <label htmlFor={props.id} className="absolute text-gray-900 duration-300 transform -translate-y-8 scale-75 top-4 z-0 origin-[0] peer-focus:start-0 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:left-5  peer-focus:scale-75 peer-focus:-translate-y-8 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-placeholder-shown:text-gray-400">{props.label}</label>}
        </div>
    );
});
